
// Common toast messages for reuse throughout the application
export const commonToasts = {
  // Listing-related toasts
  listingCreated: {
    title: "Shpallja u krijua",
    description: "Shpallja juaj u krijua me sukses.",
  },
  listingUpdated: {
    title: "Shpallja u përditësua",
    description: "Shpallja juaj u përditësua me sukses.",
  },
  listingDeleted: {
    title: "Shpallja u fshi",
    description: "Shpallja juaj u fshi me sukses.",
  },
  listingActivated: {
    title: "Shpallja u aktivizua",
    description: "Shpallja juaj u aktivizua me sukses.",
  },
  listingDeactivated: {
    title: "Shpallja u çaktivizua",
    description: "Shpallja juaj u çaktivizua me sukses.",
  },
  listingActivationBlocked: {
    title: "Nuk mund të aktivizohet",
    description: "Ju nuk keni kredite të disponueshme për të aktivizuar një shpallje.",
    variant: "destructive" as "destructive",
  },
  listingDeleteBlocked: {
    title: "Nuk mund të fshihet",
    description: "Kjo shpallje ka porosi aktive dhe nuk mund të fshihet. Mund ta çaktivizoni atë.",
    variant: "destructive" as "destructive",
  },
  
  // Stock-related toasts
  stockUpdated: {
    title: "Stoku u përditësua",
    description: "Stoku u përditësua me sukses.",
  },
  stockDeactivated: {
    title: "Shpallja u çaktivizua",
    description: "Shpallja juaj u çaktivizua automatikisht sepse stoku u bë 0.",
  },
  stockReactivated: {
    title: "Shpallja u riaktivizua",
    description: "Shpallja juaj u riaktivizua automatikisht sepse stoku u rrit nga 0.",
  },
  
  // User account toasts
  loginSuccess: {
    title: "Mirësevini",
    description: "Ju keni hyrë me sukses në llogarinë tuaj.",
  },
  logoutSuccess: {
    title: "Mirupafshim",
    description: "Ju keni dalë me sukses nga llogaria juaj.",
  },
  loginError: {
    title: "Gabim gjatë hyrjes",
    description: "Ka ndodhur një gabim gjatë hyrjes. Ju lutemi provoni përsëri.",
    variant: "destructive" as "destructive",
  },
  
  // Error toasts
  genericError: {
    title: "Gabim",
    description: "Ndodhi një gabim i papritur. Ju lutemi provoni përsëri.",
    variant: "destructive" as "destructive",
  },
  error: {
    title: "Gabim",
    description: "Ndodhi një gabim. Ju lutemi provoni përsëri.",
    variant: "destructive" as "destructive",
  },
  
  // Success toasts
  success: {
    title: "Sukses",
    description: "Veprimi u krye me sukses.",
  },
  
  // Order-related toasts
  orderDeleted: {
    title: "Porosia u fshi",
    description: "Porosia u fshi me sukses.",
  },
  orderDeleteBlocked: {
    title: "Nuk mund të fshihet",
    description: "Vetëm porositë me status 'Përfunduar' mund të fshihen.",
    variant: "destructive" as "destructive",
  }
};
